// extracted by mini-css-extract-plugin
export var buttonContainer = "_99-1";
export var fontSizeSelect = "_99-3";
export var formatSelect = "_99-2";
export var formats = "_99-4";
export var hidden = "_99-5";
export var icon = "_99-6";
export var select = "_99-0";